<!-- Sidebar -->
<div id="wrapper" [class.toggled]="toggled">

    <div id="toggler-wrapper">
        <button type="button" (click)="toggled = !toggled" id="sidebarCollapse" class="btn btn-action">
            <i *ngIf="!toggled" class="fa fa-chevron-left"></i>
            <i *ngIf="toggled" class="fa fa-chevron-right"></i>
        </button>
    </div>

    <div id="sidebar-wrapper">

        <ul *ngIf="tittle" class="sidebar-nav">
            <li class="sidebar-brand"> <a> {{tittle}} </a> </li>
        </ul>
        <div class="sidebar-container">
            <ng-container #target></ng-container>
        </div>
    </div> <!-- /#sidebar-wrapper -->
</div>